module["exports"] = [
  "France"
];
